import template from "./collect-payment-method-modal.html";

const CollectPaymentMethodModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class CollectPaymentMethodModalController {
    /* @ngInject */
    constructor($rootScope, Stripe) {
      this.$rootScope = $rootScope;
      this.Stripe = Stripe;
    }

    async $onInit() {
      this.card = null;
      this.cardError = null;
    }

    async save() {
      const result = await this.Stripe.createToken(this.card);
      if (result.error) {
        this.cardError = result.error.message;
        this.$rootScope.$applyAsync();
        this.close();
      } else {
        return this.close({ $value: result.token.id });
      }
    }

    close() {
      return this.dismiss({ $value: "cancel" });
    }
  },
};

export default CollectPaymentMethodModalComponent;
